import { Dependencies } from "../../models"

export interface Award {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    imageUrl: string
    categoryIds: string[]
    amount: number
    dependencies: Dependencies
}

export interface AwardListItem extends Omit<Award, "categoryIds" | "dependencies" | "amount"> {
    categoryIds?: string[]
    categoryNames?: string[]
}

export interface PagedAward {
    items: AwardListItem[]
    totalCount: number
}

export const AWARD_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    descriptions: "Opis",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    image: "Slika",
    amount: "Iznos",
    categoryIds: "Kategorije",
    dependencies: "Ovisnosti",
}
